import { render, staticRenderFns } from "./CallcentreQueueList.vue?vue&type=template&id=2e641f15&"
import script from "./CallcentreQueueList.vue?vue&type=script&lang=js&"
export * from "./CallcentreQueueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports